/* global G */
import { curry } from 'lib/util'
import { isOlderThanOneDay } from 'lib/util/date'

const responseColorMapping = {
  'optionmanagement.error.device-outdated': 'warning',
  'optionmanagement.error.device-update': 'warning',
}

const responseTextMapping = {
  'optionmanagement.error.device-outdated': 'label.deviceOutdated',
  'optionmanagement.error.device-update': 'label.deviceUpdate',
}

/**
 * Get Pin Status Event Handler
 *
 * Returns the status of the current PIN.
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {Promise<[{value: *, color: string, backgroundColor: string}]|[{}]>}
 */
const getPinStatus = async (module, component, event) => {
  const intl = module[G.ADAPTER][G.INTL]
  const { value = {} } = module[G.MODEL][G.CACHE] || {}
  const response = value?.response || {}
  const submitDate = value?.submitDate || null

  if (response?.messageKey) {
    const tKey = responseTextMapping?.[response?.messageKey]
    return [{
      value: tKey
        ? await intl._t(tKey, {
          _key: tKey,
          ns: 'optionManagement',
          defaultValue: 'Software version is outdated',
        })
        : response?.message,
      color: `${responseColorMapping?.[response?.messageKey] || 'error'}.700`,
      backgroundColor: `${responseColorMapping?.[response?.messageKey] || 'error'}.50`,
    }]
  }

  if (isOlderThanOneDay(submitDate)) {
    return [{
      value: await intl._t('label.pinOutdated', {
        _key: 'label.pinOutdated',
        ns: 'optionManagement',
        defaultValue: 'PIN is outdated',
      }),
      color: 'error.700',
      backgroundColor: 'error.50',
    }]
  }

  return [{}]
}

export default curry(getPinStatus)
